import { computed, ExtractPropTypes, ref } from 'vue'
import { useArticleLinks } from '../articleLinks'
import { ARTICLE_CARD_PROPS } from './types'

const SHOW_CHECKMARK_DURATION_MS = 1500
type ArticleCardProps = ExtractPropTypes<typeof ARTICLE_CARD_PROPS>

/**
 * ArticleCard controller
 * @param props
 * @returns state and actions
 */
export default function (props: ArticleCardProps) {
  const showCheckmark = ref(false)
  const externalThymeboxPatientId = computed(
    () => props.externalThymeboxPatientId
  )
  const { viewArticle, copyLink: baseCopyLink } = useArticleLinks(
    externalThymeboxPatientId
  )

  /**
   * Copies the article link to the clipboard and shows a checkmark for 1.5 seconds.
   * @param url - The URL to copy to the clipboard.
   */
  async function copyLink(url: string) {
    await baseCopyLink(url)
    showCheckmark.value = true
    setTimeout(() => {
      showCheckmark.value = false
    }, SHOW_CHECKMARK_DURATION_MS)
  }

  return {
    viewArticle,
    copyLink,
    showCheckmark,
  }
}
